import {mapState} from 'vuex';

export default {
  components: {
    ConfirmTextColumn: () => import('./columns/ConfirmText'),
    EditedTextColumn: () => import('./columns/EditedText'),
    PushFirstDateColumn: () => import('./columns/PushFirstDate'),
    PushStatusColumn: () => import('./columns/PushStatus'),
    PushSuccessColumn: () => import('./columns/PushSuccess'),
    PeriodColumn: () => import('./columns/Period'),
    RepeatStrategyColumn: () => import('./columns/RepeatStrategy'),
    RepeatTypeTextColumn: () => import('./columns/RepeatTypeText'),
    RepeatReserveTimeColumn: () => import('./columns/RepeatReserveTime'),
    ReadDateColumn: () => import('./columns/ReadDate'),
    RcpDescColumn: () => import('./columns/RcpDescLink'),
  },
  data() {
    return {
      customNewsTypes: {
        BIRTHDAY: {full: '생일', short: '생일'},
        NEW_INSTALL_5DAYS: {full: '신규설치 5일차', short: '신규5일'},
        UNUSED_WARNING: {full: '스피커 미사용 경고 대상자', short: '경고'},
        BAD_KEYWORD_3DAYS: {full: '부정키워드 3일 연속', short: '부정키워드'},
        DEMENTIA_UNUSED_30DAYS: {
          full: '기억검사 30일 미사용',
          short: '기억30일',
        },
        BRAIN_UNUSED_7DAYS: {full: '두뇌톡톡 7일 미사용', short: '두뇌7일'},
        MINDGYM_UNUSED_7DAYS: {full: '마음체조 7일 미사용', short: '체조7일'},

        SPK_CONT_USED_2DAYS: {
          full: '스피커 2일 연속사용',
          short: '스피커2일',
        },
        SPK_CONT_USED_4DAYS: {
          full: '스피커 4일 연속사용',
          short: '스피커4일',
        },
        SPK_CONT_USED_7DAYS: {
          full: '스피커 7일 연속사용',
          short: '스피커7일',
        },
        SPK_CONT_USED_15DAYS: {
          full: '스피커 15일 연속사용',
          short: '스피커15일',
        },
        SPK_CONT_USED_30DAYS: {
          full: '스피커 30일 연속사용',
          short: '스피커30일',
        },
      },
    };
  },
  computed: {
    ...mapState(['user', 'permissions']),
    isRegister() {
      return this.permissions.register.accessable;
    },
  },
  methods: {
    // popups
    async openGeneralRegister() {
      const popupModule = await import('./popups/GeneralRegister');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openGeneralUpdater() {
      const popupModule = await import('./popups/GeneralUpdater');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openGeneralDetail() {
      const popupModule = await import('./popups/GeneralDetail');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openGeneralSendLogs() {
      const popupModule = await import('./popups/GeneralSendLogs');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openGeneralRecipientList() {
      const popupModule = await import('./popups/GeneralRecipientList');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openRepeatRecipientList() {
      const popupModule = await import('./popups/RepeatRecipientList');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openRecipientSelector() {
      const popupModule = await import('./popups/RecipientSelector');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openRepeatRegister() {
      const popupModule = await import('./popups/RepeatRegister');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openRepeatUpdater() {
      const popupModule = await import('./popups/RepeatUpdater');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openRepeatDetail() {
      const popupModule = await import('./popups/RepeatDetail');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openRepeatSendLogs() {
      const popupModule = await import('./popups/RepeatSendLogs');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openRepeatSendLogsRcpList() {
      const popupModule = await import('./popups/RepeatSendLogsRcpList');
      this.openPopup(popupModule.default, ...arguments);
    },
    async openRepeatContentSample() {
      const popupModule = await import('./popups/RepeatContentSample');
      this.openPopup(popupModule.default, ...arguments);
    },
    openRepeatSendLogsByRowData(rowData) {
      const props = {
        newsId: rowData.id,
        newsType: rowData.newsType,
        customNewsType: rowData.customNewsType,
      };
      this.openRepeatSendLogs(props);
    },
    deleteNews(newsId, newsType = 'general') {
      confirm(`${newsId}번 소식을 삭제하시겠습니까?`).then(() => {
        this.$axios.delete(`/admin/v2/news/${newsType.toLowerCase()}/${newsId}`).then(() => {
          alert('삭제되었습니다.');
          this.loadData(true);
        });
      });
    },
    deleteNewsBulk(newsIdArr) {
      if (_.isEmpty(newsIdArr)) {
        alert('삭제할 소식을 선택해주세요.');
        return;
      }
      confirm(`한번 삭제한 소식은 복구할 수 없습니다.\n선택한 ${newsIdArr.length}개의 소식을 삭제하시겠습니까?`).then(() => {
        this.$axios
          .delete(`/admin/v2/news/bulk`, {
            params: {news_ids: newsIdArr.join(',')},
          })
          .then(() => {
            alert('선택한 소식이 삭제되었습니다.');
            this.loadData(true);
          });
      });
    },
    async resend(rcpList) {
      if (!this.selectedList.length) {
        console.error('대상자가 없습니다.');
        return;
      }
      let rcpTarget = `${rcpList[0].rcpName}님`;
      if (rcpList.length > 1) {
        rcpTarget += ` 외 ${rcpList.length - 1}명`;
      }
      const message = `${rcpTarget}에게 다시 알림을 보내시겠습니까?\n(전체 소식 순서가 변경되지는 않습니다.)`;
      confirm(message).then(async () => {
        try {
          await this.$axios.put(`/admin/happy/${this.options.newsId}/resend`, {
            rcpIdList: _.map(rcpList, (item) => item.rcpId),
          });
          alert(`${rcpTarget}에게 알림 재전송 하였습니다.`);
          this.$refs.table.loadData();
          if (this.options.onResend) {
            this.options.onResend();
          }
        } catch (e) {
          // error
        }
      });
    },
    failMsg(code) {
      switch (code) {
        case 'NOT_FOUND_DEVICE':
          return 'NUGU 디바이스 정보를 찾을 수 없습니다.<br>TID와 Device ID가 올바른지 확인해주세요.';
        case 'TOKEN_EXPIRED':
          return 'NUGU 디바이스 토큰이 만료되었습니다.';
        case 'DEVICE_NETWORK_ERROR':
          return 'NUGU 디바이스가 연결되어 있지 않았습니다.<br>전원 및 네트워크 연결 상태 확인이 필요합니다.';
        case 'UNKNOWN':
          return '일시적인 오류로 알림 전송되지 못했습니다.';
      }
    },
    getNewsTypeText(newsType) {
      switch (newsType) {
        case 'REPEAT':
          return '반복소식';
        case 'CUSTOM':
          return '맞춤소식';
        case 'NEWS':
        default:
          return '일반소식';
      }
    },
    getNewsTypeCombineText(newsType, customNewsType) {
      const typeText = this.getNewsTypeText(newsType);
      if (newsType != 'CUSTOM') {
        return typeText;
      }
      return `${typeText} [${this.getCustomNewsText(customNewsType)}]`;
    },
    getGeneralSendTypeText(sendType) {
      switch (sendType) {
        case 'RESEND':
          return '알림재전송';
        case 'SNOOZED':
          return '미확인 알림';
        case 'FIRST':
          return '최초 전송';
        default:
          return '-';
      }
    },
    getRepeatSendTypeText(sendType) {
      switch (sendType) {
        case 'RESERVED':
          return '예약시간';
        case 'SNOOZED':
          return '미확인 알림';
        default:
          return '-';
      }
    },
    getRepeatStrategyText(data) {
      if (!data) {
        return '-';
      }
      if (data.period === 'DAILY') {
        return '매일';
      } else {
        const dayOfWeekText = '월화수목금토일'
          .split('')
          .reduce((result, currentVal, index) => {
            if (data.dayOfWeek[index]) {
              result.push(currentVal);
            }
            return result;
          }, [])
          .join(',');
        return `매주 ${dayOfWeekText}`;
      }
    },
    getCustomNewsText(customType, isShort = false) {
      const item = this.customNewsTypes[customType];
      const key = isShort ? 'short' : 'full';
      return item ? item[key] : '-';
    },
  },
};
